// onboard
import { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

import WebbDividerSmall from "../webb/webb-divider-sm";
import WebbDividerMedium from "../webb/webb-divider-md";
import WebbModuleInfo from "../webb/webb-module-info";
import WebbLoader from "../webb/webb-loader";
import FormNeeded from "../webb/form-needed";

import { GetAuthUser, GetNewUser } from "../../services/srvc-auth-user";
import { CreateUserAccount } from "../../services/srvc-accounts-realm";

export default function OnboardUserAccountModule() {

  const asset = GetAuthUser();
  const usrx = GetNewUser();
  console.log(usrx)
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(false);
  const [text, setText] = useState('');

  const [data, setData] = useState({
    acnt: '',
    ntwk: 'devnet-nft'
  });

  // form validation
  useEffect( () => {
    setForm(false)
    if (data.acnt !=='') 
      setForm(true);
  },[data]);

  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form) 
    {
      setLoading(true);

      const result = await CreateUserAccount({
        data: {acnt: data.acnt, ntwk: data.ntwk, user: usrx.usid},
        user: usrx.usid
      })
      console.log (result)
      history.push('/account/next')
      setLoading(false);
      //resetForm();
    }
    else {
      setText('Please enter details')
    }
  }

  if (loading){ return ( <> <WebbLoader /> </> ) }
  
  return (
  <>
    {/* info */}
    <WebbDividerSmall />
    <WebbModuleInfo data={{ text: 'Please Link Your NFT Devnet Account' }} />

    {/* form */}
    <form onSubmit={handleSubmit}>
      <div className="">

        <div className="form-group mb-3">
          <label className="form-label small">XRPL Account <FormNeeded /></label>
          <input type="text" 
            className="form-control height-md" 
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.acnt}
            onChange={({ target }) => {handleChange("acnt", target.value); setText('');}}
            placeholder="">
          </input>
        </div>

      </div>
      
      {/* actn */}
      <WebbDividerMedium />
      <div className="">
        <div className="d-grid">
          <button className={`btn height-md btn-primary back-color-main border-none rounded-pill`}
            disabled={!form}
          ><small>Save & Continue</small>
          </button>
        </div>
      </div>

    </form>
    

    <WebbDividerMedium />
    {/* text */}
    <div className="mb-3">
      <p className="small mt-2">
        Note: This only works with NFT-Devnet Accounts.
        Please get one at 
        <a href='https://xrpl.org/xrp-testnet-faucet.html' 
          target={'_blank'} className='ms-2 fw-bold'
          >NFT Devnet Credentials 
        </a>
      </p>
    </div>

    <WebbDividerMedium />
    <WebbDividerMedium />

  </>
  )
}